@if (idTag(); as tag) {
  <div class="details-wrapper">
    <div class="column">
      <h3>Brikdetaljer</h3>
      <table class="table">
        <tbody>
          <tr valign="top">
            <td>
              <strong>RFID:</strong>
            </td>
            <td class="align-right">
              <div>
                {{ tag.idToken | emptyDash }}
              </div>
            </td>
          </tr>
          <tr valign="top">
            <td>
              <strong>PSP nummer, AZident:</strong>
            </td>
            <td class="align-right">
              <div>
                {{ tag.externalReference | emptyDash }}
              </div>
            </td>
          </tr>
          <tr valign="top">
            <td>
              <strong>Briktype:</strong>
            </td>
            <td>
              @let idTagType = tag.idTagType.toString();
              <div class="flex">
                @if (idTagType === idTagTypeEnum[idTagTypeEnum.FleetIdTag]) {
                  <div class="margin--left-auto icon-with-text">
                    <svg class="icon-20" aria-hidden="false" aria-label="Flådebrik" [matTooltip]="'Flådebils-brik'">
                      <use href="assets/images/ok-icons-sprite.svg#building-s"></use>
                    </svg>
                    <span>Flådebrik</span>
                  </div>
                } @else if (idTagType === idTagTypeEnum[idTagTypeEnum.ChargingUserIdTag]) {
                  <div class="margin--left-auto icon-with-text">
                    <mat-icon aria-hidden="false" aria-label="Bruger">person_outline</mat-icon>
                    <span>Bruger</span>
                  </div>
                } @else {
                  <div class="margin--left-auto">-</div>
                }
              </div>
            </td>
          </tr>
          @if (idTagType === idTagTypeEnum[idTagTypeEnum.ChargingUserIdTag]) {
            <tr valign="top">
              <td>
                <strong>Tilknyttet bruger:</strong>
              </td>
              <td class="align-right">
                <a (click)="goToChargingUser(tag.chargingUserId)" class="blue" style="cursor: pointer">
                  {{ chargingUserName }}
                </a>
              </td>
            </tr>
          }
          @if (idTagType === idTagTypeEnum[idTagTypeEnum.ChargingUserIdTag]) {
            <tr valign="top">
              <td>
                <strong>Brugers afdeling</strong>
              </td>
              <td class="align-right">
                {{ tag.chargingUserDepartmentName | emptyDash }}
              </td>
            </tr>
          }
          @if (idTagType === idTagTypeEnum[idTagTypeEnum.ChargingUserIdTag]) {
            <tr valign="top">
              <td>
                <strong>Har firmabil?</strong>
              </td>
              <td class="align-right">
                <div>
                  @if (hasCompanyCar) {
                    Ja
                  }
                  @if (!hasCompanyCar) {
                    Nej
                  }
                </div>
              </td>
            </tr>
          }
          <tr valign="top">
            <td>
              <strong>Afregnes på aftalenr/kontonr</strong>
            </td>
            <td class="align-right">
              {{ agreementNumberForDisplay | emptyDash }}
            </td>
          </tr>
          @if (idTagType === idTagTypeEnum[idTagTypeEnum.FleetIdTag]) {
            <tr valign="top">
              <td>
                <strong>Aftalenummer:</strong>
              </td>
              <td class="align-right">
                <div>
                  {{ agreementNumberForDisplay | emptyDash }}
                </div>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>

    <div class="column">
      <h3>Modtageradresse</h3>
      <table class="table">
        <tbody>
          <tr valign="top">
            <td>
              <strong>{{ addressInfo }}:</strong>
            </td>
            <td class="align-right">
              <div>{{ address | emptyDash }}</div>
            </td>
          </tr>
          <tr valign="top">
            <td>
              <strong>Att.:</strong>
            </td>
            <td class="align-right">
              <div>
                {{ tag.attention | emptyDash }}
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <h3>Adgangsgrupper</h3>
      @if (accessGroups$ | async; as accessGroups) {
        @if (accessGroups.length === 0) {
          <em>Der er ingen tilknyttede adgangsgrupper</em>
        }
        @if (accessGroups.length > 0) {
          <table class="table table--center-vert">
            <thead>
              <tr>
                <th class="align-left">Navn</th>
                <th class="align-left">Rabat</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              @for (accessGroup of accessGroups; track accessGroup) {
                <tr
                  valign="top"
                  [class.muted]="accessGroup.deleted"
                  [matTooltip]="accessGroup.deleted ? 'Adgangsgruppen slettet fra bruger d.' + (accessGroup.deleted | date: 'short') : ''">
                  <td>{{ accessGroup.name }}</td>
                  <td>
                    @if (accessGroup.discountType === discountType.FixedAmount) {
                      {{ accessGroup.amount | dkCurrency }}
                    } @else if (accessGroup.discountType === discountType.Percentages) {
                      {{ accessGroup.amount | number: '1.2-2' }}%
                    }
                  </td>
                  <td>
                    <div class="flex">
                      <a
                        [routerLink]="['/access-groups']"
                        [queryParams]="{ accessGroupIdentifier: accessGroup.accessGroupIdentifier }"
                        target="_new"
                        class="blue icon-with-text margin--right-m margin--left-auto">
                        <mat-icon class="material-icons">find_in_page</mat-icon>
                        <span>Se detaljer</span>
                      </a>
                    </div>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        }
      }
    </div>
  </div>
}
